{
	"title": "Afrekenen",
	"validation": {
		"method": "Kies hoe je betaalt.",
		"terms": "Vink het akkoord aan om te betalen.",
		"email": "Vul een e-mailadres in, zoals naam@voorbeeld.nl.",
		"firstName": "Vul je voornaam in.",
		"lastName": "Vul je achternaam in.",
		"street": "Vul je straat in.",
		"houseNumber": "Vul je huisnummer in.",
		"city": "Vul je plaats in.",
		"postcode": {
			"NL": "Vul een postcode in zoals 3911 AB.",
			"BE": "Vul een postcode in zoals 1000."
		}
	},
	"problem": {
		"cartChanged": "Je mand is veranderd sinds je hem bekeek: een prijs, de voorraad of je kortingscode. Kijk het overzicht na en bestel dan opnieuw.",
		"outOfStock": "Niet alles is nog op voorraad. {{lines}} Pas je mand aan en reken dan af.",
		"shortLine": "{{product}}: nog {{count}}.",
		"soldOutLine": "{{product}}: uitverkocht.",
		"someProduct": "Een product",
		"cartEmpty": "Je mand is leeg. Kies eerst wat je wilt bestellen.",
		"discountCode": "Je kortingscode geldt niet meer. Haal hem weg in je mand of probeer een andere.",
		"countryMismatch": "Je mand is uitgerekend voor bezorging in {{country}}. Kies een verzendadres in {{country}}, of verander het land in je mand.",
		"notDeliverable": "We bezorgen helaas niet in {{country}}. Kies een ander land in je mand.",
		"detailsMissing": "Vul je e-mailadres, voornaam en achternaam in.",
		"bankTransferNotAllowed": "Als gast kun je tot {{max}} per overboeking betalen. Kies iDEAL, Bancontact, creditcard of PayPal, of log in.",
		"onAccountNotAllowed": "Op rekening kan alleen met een goedgekeurd zakelijk account. Kies een andere betaalmethode.",
		"addressNotFound": "Dit adres staat niet meer in je adresboek. Kies een ander adres of vul er een in.",
		"botCheckFailed": "We konden niet controleren of je een mens bent. Wacht tot de controle klaar is en bestel opnieuw.",
		"botCheckUnavailable": "De controle tegen spam werkt even niet. Probeer het zo nog eens.",
		"rateLimited": "Je hebt het te vaak geprobeerd. Wacht even en probeer het dan nog eens.",
		"unknown": "Er ging iets mis. Probeer het zo nog eens. Zie je de bestelling straks in je mail, bestel dan niet opnieuw."
	},
	"empty": {
		"title": "Je mand is leeg.",
		"text": "Kies eerst wat je wilt bestellen, dan reken je hier af."
	},
	"back": {
		"cart": "Naar je mand",
		"assortment": "Naar het assortiment",
		"toCart": "Terug naar je mand"
	},
	"cartIssues": {
		"title": "Je mand klopt nog niet. Pas hem aan voordat je bestelt:"
	},
	"contact": {
		"guestText": "Heb je een account? Log in, dan vullen we je gegevens in. Of ga verder als gast.",
		"signIn": "Inloggen",
		"signedInAs": "Ingelogd als {{email}}",
		"business": "Zakelijk",
		"emailHint": "Hier sturen we de bevestiging en de factuur heen.",
		"phone": "Telefoon"
	},
	"shipping": {
		"choose": "Kies een verzendadres",
		"title": "Vóór 17:00 besteld, vandaag verstuurd",
		"text": "Bezorgd door [NOG INVULLEN: vervoerder], meestal [NOG INVULLEN: 1–2 werkdagen]. Track en trace per mail.",
		"free": "Gratis",
		"countryOption": "{{country}} · verzenden {{rate}}"
	},
	"billing": {
		"other": "Factuuradres is anders",
		"legend": "Factuuradres",
		"choose": "Kies een factuuradres"
	},
	"address": {
		"other": "Een ander adres",
		"company": "Bedrijfsnaam",
		"postcodePlaceholder": "3911 AB"
	},
	"payment": {
		"legend": "Betalen",
		"free": "Er valt niets te betalen: je kortingscode dekt alles.",
		"noBankTransfer": "Overboeken kan als gast tot {{max}}. Kies iDEAL, Bancontact, creditcard of PayPal, of",
		"noBankTransferSignIn": "log in"
	},
	"method": {
		"ideal": {
			"label": "iDEAL",
			"hint": "Je bank betaalt direct",
			"mark": "iDEAL"
		},
		"bancontact": {
			"label": "Bancontact",
			"hint": "Voor België",
			"mark": "Bancontact"
		},
		"card": {
			"label": "Creditcard",
			"hint": "Visa, Mastercard",
			"mark": "Creditcard"
		},
		"paypal": {
			"label": "PayPal",
			"hint": "Inloggen bij PayPal",
			"mark": "PayPal"
		},
		"bankTransfer": {
			"label": "Overboeking",
			"hint": "Je maakt het bedrag binnen 7 dagen over. We versturen zodra het binnen is.",
			"mark": "Overboeking"
		},
		"onAccount": {
			"label": "Op rekening",
			"hint": "Betalen binnen {{term}} na factuurdatum.",
			"mark": "Factuur",
			"company": "Factuur op naam van {{company}}, btw-nummer {{vatId}}."
		}
	},
	"finish": {
		"newsletter": "Stuur me de nieuwsbrief, met af en toe een aanbieding. Afmelden kan altijd.",
		"termsBefore": "Ik ga akkoord met de",
		"termsLink": "algemene voorwaarden",
		"termsAfter": ".",
		"pay": "Betalen · {{amount}}",
		"order": "Bestellen · {{amount}}",
		"orderFree": "Bestellen",
		"toPayNl": "Naar het betalen…",
		"payNlNote": "Je gaat naar Pay.nl om te betalen en komt daarna terug op je bevestiging.",
		"orderNote": "Je krijgt de bevestiging meteen, en per mail."
	},
	"summary": {
		"title": "Overzicht",
		"quantity": "{{count}}×",
		"changeCart": "Mand aanpassen"
	},
	"payAgain": {
		"paid": "Deze bestelling is al betaald.",
		"expired": "Deze bestelling is verlopen. Bestel opnieuw vanuit je mand.",
		"cancelled": "Deze bestelling is geannuleerd. Bestel opnieuw vanuit je mand.",
		"nothingToPay": "Er valt niets te betalen.",
		"methodNotAllowed": "Overboeken kan alleen bij een nieuwe bestelling. Kies iDEAL, Bancontact, creditcard of PayPal.",
		"refused": "Pay.nl wees de betaling af. Kies een andere betaalmethode.",
		"unavailable": "Pay.nl is even niet bereikbaar. Probeer het zo nog eens.",
		"notFound": "We kunnen deze bestelling hier niet meer betalen. Kijk in je mail, of neem contact met ons op.",
		"unknown": "Er ging iets mis. Probeer het zo nog eens.",
		"legend": "Kies een betaalmethode",
		"submit": "Opnieuw betalen · {{amount}}",
		"busy": "Even geduld…"
	},
	"order": {
		"checking": "We kijken hoe je betaling ervoor staat…",
		"testMode": "Testmodus: er is geen echt geld betaald.",
		"byMail": "Je krijgt de bevestiging van je bestelling per mail.",
		"number": "Bestelnummer",
		"mailedTo": "bevestiging gestuurd naar {{email}}",
		"details": "Je bestelling",
		"deliverTo": "Bezorgen op: {{address}}",
		"billTo": "Factuur naar: {{address}}",
		"toAccount": "Naar je bestellingen",
		"shopOn": "Verder winkelen"
	},
	"status": {
		"paid": {
			"title": "Bedankt, je bestelling is betaald",
			"free": "Er viel niets te betalen. We pakken je bestelling in en mailen je zodra hij onderweg is."
		},
		"pending": {
			"title": "We wachten op je betaling",
			"text": "Je betaling is nog niet bij ons binnen. Dat kan een paar minuten duren. Deze pagina werkt zichzelf bij; je krijgt ook een mail zodra het gelukt is.",
			"long": "Duurt het langer? Kijk in je bankapp of de betaling is afgeschreven, of neem contact op.",
			"recheck": "Opnieuw laden",
			"contact": "Contact"
		},
		"bankTransfer": {
			"title": "Bedankt voor je bestelling",
			"text": "Maak {{amount}} binnen 7 dagen over, met het betalingskenmerk erbij.",
			"textBefore": "Maak {{amount}} binnen 7 dagen over, uiterlijk {{date}}, met het betalingskenmerk erbij.",
			"amount": "Bedrag",
			"reference": "Betalingskenmerk",
			"referenceByMail": "Komt per mail",
			"payBefore": "Uiterlijk",
			"payUrl": "Bekijk het rekeningnummer bij Pay.nl",
			"after": "We versturen je bestelling zodra het geld binnen is. Is het na 7 dagen niet binnen, dan vervalt de bestelling."
		},
		"onAccount": {
			"title": "Bedankt voor je bestelling",
			"text": "We versturen je bestelling. Je krijgt de factuur per mail: betaal {{amount}} uiterlijk {{date}}.",
			"textNoDate": "We versturen je bestelling. Je krijgt de factuur per mail: betaal {{amount}} binnen je betaaltermijn.",
			"reference": "Zet dit kenmerk bij je overboeking:"
		},
		"notPaid": {
			"failed": "Betaling niet gelukt",
			"cancelled": "Je hebt de betaling afgebroken",
			"expired": "Je betaling is verlopen",
			"refused": "Je betaling kon niet starten",
			"unavailable": "Je betaling kon niet starten",
			"nothingTaken": "Er is niets afgeschreven",
			"openUntil": "Je bestelling ligt nog tot {{time}} voor je klaar. Daarna vervalt hij.",
			"open": "Je bestelling ligt nog voor je klaar. Na een tijd zonder betaling vervalt hij.",
			"elsewhere": "Opnieuw betalen kan alleen in het tabblad waarin je bestelde. Lukt dat niet, bestel dan opnieuw vanuit je mand."
		},
		"expired": {
			"title": "Deze bestelling is verlopen",
			"text": "Hij is niet op tijd betaald, dus we versturen hem niet. Er is niets afgeschreven. Bestel opnieuw als je hem nog wilt."
		},
		"unknown": {
			"title": "Bedankt voor je bestelling",
			"text": "Hoe je betaling ervoor staat, lezen we in deze browser niet terug. Je krijgt de bevestiging per mail."
		}
	},
	"errorSummary": {
		"title_one": "Nog {{count}} ding om aan te vullen",
		"title_other": "Nog {{count}} dingen om aan te vullen",
		"field": {
			"email": "e-mailadres",
			"firstName": "voornaam",
			"lastName": "achternaam",
			"phone": "telefoonnummer",
			"shipping": "verzendadres",
			"street": "straat",
			"houseNumber": "huisnummer",
			"houseNumberAddition": "toevoeging",
			"postcode": "postcode",
			"city": "plaats",
			"country": "land",
			"company": "bedrijfsnaam",
			"billing": "factuuradres",
			"paymentMethod": "betaalmethode",
			"newsletter": "de controle voor de nieuwsbrief",
			"termsAccepted": "het akkoord met de voorwaarden",
			"turnstileToken": "de controle tegen spam"
		}
	},
	"soldOut": {
		"title_one": "{{products}} is net uitverkocht",
		"title_other": "{{products}} zijn net uitverkocht",
		"text": "We hebben het uit je bestelling gehaald. Je totaal is aangepast."
	},
	"steps": {
		"signIn": "Inloggen of als gast",
		"contact": "Contact en adres",
		"shipping": "Verzending",
		"payment": "Betalen",
		"paymentVia": "via Pay.nl",
		"summary": "Overzicht"
	},
	"next": {
		"title": "Wat er nu gebeurt",
		"ship": {
			"title": "Vóór 17:00 besteld, vandaag verstuurd",
			"text": "Op een werkdag vóór 17:00 besteld, dan gaat je pakket dezelfde dag de deur uit. Later besteld: de volgende werkdag."
		},
		"track": {
			"title": "Track en trace per mail",
			"text": "Zodra het pakket onderweg is, krijg je de link."
		},
		"reorder": {
			"title": "Opnieuw bestellen met één knop",
			"text": "Geen abonnement. Bij je volgende bestelling staat deze klaar in je account."
		},
		"reorderGuest": {
			"title": "Opnieuw bestellen met één knop",
			"text": "Geen abonnement. In de mail dat je pakket onderweg is, staat de knop Bestel opnieuw."
		}
	},
	"createAccount": {
		"title": "Maak een account met één klik",
		"text": "We gebruiken je gegevens van deze bestelling. Dan bestel je de volgende keer opnieuw met één knop.",
		"password": "Kies een wachtwoord",
		"phone": "Telefoon",
		"phoneHint": "Een account vraagt een telefoonnummer, voor als er iets is met de bezorging.",
		"submit": "Account maken",
		"doneTitle": "Kijk in je mail",
		"done": "We hebben een link gestuurd naar {{email}}. Klik erop om je account te bevestigen."
	}
}
